import React from 'react';
import './Componenst.css';
import KanModel from '../models/KanModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createKan, showError } from '../ViewCreator';

function Kan({ changeSearch, searchModel, setView, addNew = () => {}, isAdd = false }) {

    const personModel = new KanModel();


    const clearSubmit = () => {
        document.getElementById('shifrKan').value = '';
        document.getElementById('lineKan').value = '';
        document.getElementById('dateComingsKan').value = '';
        document.getElementById('dateBeginKan').value = '';
        document.getElementById('dateEndKan').value = '';
        document.getElementById('addressKan').value = '';
        document.getElementById('jobKan').value = '';
        document.getElementById('descKan').value = '';
        personModel.shifrKan = ''
        personModel.lineKan = ''
        personModel.dateComingsKan = ''
        personModel.dateBeginKan = ''
        personModel.dateEndKan = ''
        personModel.addressKan = ''
        personModel.jobKan = ''
        personModel.descKan = ''
        if (searchModel != undefined) {
            searchModel.bs.shifrKan = ''
            searchModel.bs.lineKan = ''
            searchModel.bs.dateComingsKan = ''
            searchModel.bs.dateBeginKan = ''
            searchModel.bs.dateEndKan = ''
            searchModel.bs.addressKan = ''
            searchModel.bs.jobKan = ''
            searchModel.bs.descKan = ''
        }
    }

    const addSubmit = () => {
     
        if (personModel.shifrKan == undefined || personModel.shifrKan == '') {
            showError('Шифр не може бути пустим')
            return;
        }

        if (personModel.lineKan == undefined || personModel.lineKan == '') {
            showError('Номер не може бути пустим')
            return;
        }
    
            isUniq()
      }
    
      const isUniq = () => {
          var path = ip + '/api/kan/search';
          personModel.searchModel = new SearchModel()
          var pp = new KanModel();
          pp.shifrKan = personModel.shifrKan
          pp.lineKan = personModel.lineKan
          var bd = encryptAes(JSON.stringify(pp))
          const requestOptions = {
            headers: {
              'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
          };
          fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
              const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
              const text = decoder.decode(buffer);
              try {
                var result = JSON.parse(text);
                 showError(result.msg)
              } catch (error) {
                const decryptedText = decryptAes(text);
                var result = JSON.parse(decryptedText);
                storeKey('test_data', result.key);
      
                if (result.data.length > 0) {
                  Swal.fire({
                      title: 'Запис уже існує',
                      //text: "Оновити інформацію?",
                      icon: 'warning',
                      html:
                      'Запис з такими даними вже існує, Ви можете ' +
                      '<a href="/kan?id='+result.data[0].id+'" style="color:#FFFFFF;"  target="_blank">переглянути запис</a>',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                      }).then((result) => {
                      })
                    sendSearch()
                } else {
                  Swal.fire({
                    title: 'Ви дійсно бажаєте створити новий запис',
                    //text: "Оновити інформацію?",
                    icon: 'question',
                    html:
                    '',
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Створити',
                    denyButtonText: 'Оновити',
      
                    background: '#2B2B2B',
                    color: '#FFF'
                  }).then((result) => {
                    addNewKan()
                    })
                  
                }
              }
            })
        }
    
        const addNewKan = () => {
          var path = ip + '/api/kan/add';
          personModel.searchModel = new SearchModel()
          var bd = encryptAes(JSON.stringify(personModel))
          const requestOptions = {
            headers: {
              'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
          };
          fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
              const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
              const text = decoder.decode(buffer);
              try {
                var result = JSON.parse(text);
                 showError(result.msg)
                
      
              } catch (error) {
                const decryptedText = decryptAes(text);
                var result = JSON.parse(decryptedText);
                storeKey('test_data', result.key);
                if (isAdd) {
                  addNew(result.data, 20010)
                  clearSubmit()
                } else {
                window.open("/edit/kan?id="+result.data, "_self")
                }
              }
            })
        }

    const sendKanFullScreen = (id) => {
        window.open("/kan?id=" + id)
    }

    const sendKan = (id) => {
        var path = ip + '/api/kan/id';
       var bd = encryptAes(id)
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html; charset=win1251'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
           .then()
           .then(response => { return response.arrayBuffer() })
           .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []
                
                    var addr = result.data
                    
                    zz.push(createKan(addr))
    
                    String.prototype.replaceAt = function(index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                      }
                      var spr =  document.createElement('div');
                      spr.className = "spravka"
                      
                      spr.innerHTML = "<hr><p>"+addr.infoKan.replace(/\r\n/g, "<p>"); 
                      zz.push(spr)

                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/kan/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">Шифр: " + pers.shifrKan + "<br>Номер телефона: " + pers.lineKan;
                        z.style.display = "block";
                        const cl = i => () => {
                            sendKan(i)
                        }
                        const dblcl = i => () => {
                            sendKanFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new KanModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";

                           
                              if (id == 'lineKan') {
                                personModel.lineKan = l[index]
                            }
                            if (id == 'shifrKan') {
                                personModel.shifrKan = l[index]
                            }
                            if (id == 'dateComingsKan') {
                                personModel.dateComingsKan = l[index]
                            }
                            if (id == 'dateBeginKan') {
                                personModel.dateBeginKan = l[index]
                            }
                            if (id == 'dateEndKan') {
                                personModel.dateEndKan = l[index]
                            }
                            if (id == 'addressKan') {
                                personModel.addressKan = l[index]
                            }
                            if (id == 'jobKan') {
                                personModel.jobKan = l[index]
                            }
                            if (id == 'descKan') {
                                personModel.descKan = l[index]
                            }

                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }


       
      const shifrchange = () => {
        personModel.shifrKan = document.getElementById('shifrKan').value
        changedfield('shifrKan');
    }

    const linechange = () => {
        personModel.lineKan = document.getElementById('lineKan').value
        changedfield('lineKan');
    }

    const dateComingschange = () => {
        personModel.dateComingsKan = document.getElementById('dateComingsKan').value
        changedfield('dateComingsKan');
    }
    const dateBeginchange = () => {
       personModel.dateComingsKan = document.getElementById('dateBeginKan').value
        changedfield('dateBeginKan');
    }
    const dateEndchange = () => {
        personModel.dateEndKan = document.getElementById('dateEndKan').value
        changedfield('dateEndKan');
    }
    const jobchange = () => {
        personModel.jobKan = document.getElementById('jobKan').value
        changedfield('jobKan');
    }

    const addresschange = () => {
        personModel.addressKan = document.getElementById('addressKan').value
        changedfield('addressKan');
    }

    const descchange = () => {
        personModel.descKan = document.getElementById('descKan').value
        changedfield('descKan');
    }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-kan" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-kan" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-kan" className="input-button-right" type="submit" value="Пошук" />

               

               
          <div id="descKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="descKan" className="input-text" tabIndex="5" name="login" type="text" onChange={descchange} placeholder="Опис" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                        <div id="descKanList" className="list" />
                    </div>

                    <div id="jobKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="jobKan" className="input-text" tabIndex="4" name="login" type="text" onChange={jobchange} placeholder="Місце роботи" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}/>
                        <div id="jobKanList" className="list" />
                    </div>

                    <div id="addressKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="addressKan" className="input-text" tabIndex="4" name="login" type="text" onChange={addresschange} placeholder="Адреса" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                        <div id="addressKanList" className="list" />
                    </div>

                    <div id="dateEndKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="dateEndKan" className="input-text" tabIndex="3" name="login" type="text" onChange={dateEndchange} placeholder="Дата кінця контролю" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}/>
                        <div id="dateEndKanList" className="list" />
                    </div>

                    <div id="dateBeginKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="dateBeginKan" className="input-text" tabIndex="2" name="login" type="text" onChange={dateBeginchange} placeholder="Дата початку контролю" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus}/>
                        <div id="dateBeginKanList" className="list" />
                    </div>

                    <div id="dateComingsKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="dateComingsKan" className="input-text" tabIndex="1" name="login" type="text" onChange={dateComingschange} placeholder="Дата надходження" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                        <div id="dateComingsKanList" className="list" />
                    </div>

                    <div id="lineKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="lineKan" className="input-text" tabIndex="1" name="login" type="text" onChange={linechange} placeholder="Номер телефону" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                        <div id="lineKanList" className="list" />
                    </div>

                    <div id="shifrKanDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                        <input id="shifrKan" className="input-text" tabIndex="1" name="login" type="text" onChange={shifrchange} placeholder="Шифр" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                        <div id="shifrKanList" className="list" />
                    </div>
            </form>
        </div>
    );
}

export default Kan;